package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /admins route — redirects to /system?tab=admins.
 *
 * Content has fully moved to the «Админы» tab of SystemPage (R8).
 * Old bookmarks and external links are preserved.
 *
 * URL param mapping:
 *   ?q=…    → forwarded as ?q=…
 *   ?page=… → forwarded as ?page=…
 */
@Page("/admins")
@Composable
fun AdminsPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val params = buildString {
            val q = urlParam("q")?.ifBlank { null }
            val page = urlParam("page")?.ifBlank { null }
            if (q != null) append("&q=${encodeQueryValue(q)}")
            if (page != null) append("&page=${encodeQueryValue(page)}")
        }
        ctx.router.navigateTo("${Routes.SYSTEM}?tab=admins$params")
    }
}
